/**
 * 专栏
 * 专栏API
 *
 * OpenAPI spec version: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import ColumnContentBaseVo from '../../column/model/ColumnContentBaseVo';
import ColumnContentCreateForm from '../../column/model/ColumnContentCreateForm';
import ColumnContentDetailVo from '../../column/model/ColumnContentDetailVo';
import ColumnContentDragForm from '../../column/model/ColumnContentDragForm';
import ColumnContentEditForm from '../../column/model/ColumnContentEditForm';
import ColumnCreateForm from '../../column/model/ColumnCreateForm';
import ColumnDetailVo from '../../column/model/ColumnDetailVo';
import ColumnEditForm from '../../column/model/ColumnEditForm';
import CreatedVo from '../../column/model/CreatedVo';
import PagingColumnVo from '../../column/model/PagingColumnVo';
import UpdatedVo from '../../column/model/UpdatedVo';
  /**
   * Column service.
   * @module column/api/ColumnApi
   * @version 0.1.0
   */

  /**
   * Constructs a new ColumnApi. 
   * @alias module:column/api/ColumnApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;



    /**
     * 添加专栏
     * @param {module:column/model/ColumnCreateForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:column/model/CreatedVo}
     */
this.addColumn = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling addColumn";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = CreatedVo;
      return this.apiClient.callApi(
        '/api/column/', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 添加专栏内容(文件夹或实体内容)
     * @param {module:column/model/ColumnContentCreateForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:column/model/CreatedVo}
     */
this.addColumnContent = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling addColumnContent";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = CreatedVo;
      return this.apiClient.callApi(
        '/api/column/content', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 删除专栏
     * @param {Integer} id 专栏id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:column/model/UpdatedVo}
     */
this.deleteColumn = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling deleteColumn";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/column/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 删除专栏内容
     * @param {Integer} id 内容id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:column/model/UpdatedVo}
     */
this.deleteColumnContent = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling deleteColumnContent";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/column/content/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 拖拽节点，调整位置
     * @param {module:column/model/ColumnContentDragForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:column/model/UpdatedVo}
     */
this.dragColumnContent = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling dragColumnContent";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/column/content/drag', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 分页查询专栏列表
     * @param {Integer} pageNum 页码
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.type 专栏类型 1:数字课堂 2:数字资源 3:知识服务
     * @param {String} opts.title 专栏标题
     * @param {Integer} opts.status 状态 0:禁用 1:启用
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:column/model/PagingColumnVo}
     */
this.findPagingColumn = function(pageNum, opts) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter 'pageNum' is set
      if (pageNum == undefined || pageNum == null) {
        throw "Missing the required parameter 'pageNum' when calling findPagingColumn";
      }


      var pathParams = {
      };
      var queryParams = {
        'pageNum': pageNum,
        'type': opts['type'],
        'title': opts['title'],
        'status': opts['status']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = PagingColumnVo;
      return this.apiClient.callApi(
        '/api/column/', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 根据id查询专栏详细信息
     * @param {Integer} id 专栏id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:column/model/ColumnDetailVo}
     */
this.getColumnById = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling getColumnById";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = ColumnDetailVo;
      return this.apiClient.callApi(
        '/api/column/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 根据id查询专栏内容详细信息
     * @param {Integer} id 内容id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:column/model/ColumnContentDetailVo}
     */
this.getColumnContentById = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling getColumnContentById";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = ColumnContentDetailVo;
      return this.apiClient.callApi(
        '/api/column/content/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 获取专栏内容树形结构列表
     * @param {Integer} columnId 专栏id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:column/model/ColumnContentBaseVo>}
     */
this.getColumnContentList = function(columnId) {
      var postBody = null;

      // verify the required parameter 'columnId' is set
      if (columnId == undefined || columnId == null) {
        throw "Missing the required parameter 'columnId' when calling getColumnContentList";
      }


      var pathParams = {
        'columnId': columnId
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = [ColumnContentBaseVo];
      return this.apiClient.callApi(
        '/api/column/{columnId}/content_list', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 修改专栏
     * @param {Integer} id 专栏id
     * @param {module:column/model/ColumnEditForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:column/model/UpdatedVo}
     */
this.updateColumn = function(id, body) {
      var postBody = body;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling updateColumn";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling updateColumn";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/column/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 修改专栏内容
     * @param {Integer} id 内容id
     * @param {module:column/model/ColumnContentEditForm} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:column/model/UpdatedVo}
     */
this.updateColumnContent = function(id, body) {
      var postBody = body;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling updateColumnContent";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling updateColumnContent";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/column/content/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 修改专栏状态
     * @param {Integer} id 专栏id
     * @param {Integer} status 状态 0:禁用 1:启用
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:column/model/UpdatedVo}
     */
this.updateColumnStatus = function(id, status) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling updateColumnStatus";
      }

      // verify the required parameter 'status' is set
      if (status == undefined || status == null) {
        throw "Missing the required parameter 'status' when calling updateColumnStatus";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
        'status': status
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/column/{id}/status', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }
  };

  export default exports;
